import React, { useContext, useEffect, useState } from 'react';
import { Lang_Types, LocalStorage_keys, RoutesFlags } from '../../constants';
import { AppContext } from '../context/Provider';

export const UseGetLanguage = () => {
    const { lang, setLang } = useContext(AppContext);

    const [selectedFlag, setSelectedFlag] = useState<string>('');

    useEffect(() => {
        const spanish = Lang_Types['ES-CO'];
        const english = Lang_Types['EN-US'];

        if (window.localStorage.getItem(LocalStorage_keys.LANG_KEY) === spanish) {
            setSelectedFlag(RoutesFlags['es-CO']);
        } else if (
            window.localStorage.getItem(LocalStorage_keys.LANG_KEY) === english
        ) {
            setSelectedFlag(RoutesFlags['en-US']);
        } else {
            window.localStorage.setItem(LocalStorage_keys.LANG_KEY, spanish);
            setSelectedFlag(RoutesFlags['es-CO']);
        }
    }, [lang]);

    const handlerChangeLenguage = (lang: string) => {
        window.localStorage.setItem(LocalStorage_keys.LANG_KEY, lang);
        setLang(lang);
    };

    return { selectedFlag, handlerChangeLenguage };
};
